import React from "react";
import { Link } from "react-router-dom";
//import { Tooltip } from "../../../../components";

const CustodianDetailCard = (props) => {
  const {
    width,
    value,
    logoHeight,
    logoWidth,
    maxWidth,
    onClick,
    className = "",
  } = props;
  return (
    <div
      className={`custodian-Card ${className}`}
      style={{ width: width, maxWidth: maxWidth }}
    >
      {props.type == "img" ? (
        <div style={{ height: "100%", display: "flex", alignItems: "center" }}>
          <img
            src={props.image}
            style={{
              width: logoWidth ? logoWidth : "6.438rem",
              height: logoHeight ? logoHeight : "2rem",
            }}
          />
        </div>
      ) : null}
      <p className="title">{props.title}</p>
      {props.type == "link" ? (
        <p className="value">
          <Link onClick={onClick}>{props.value ? props.value : "-"}</Link>
        </p>
      ) : props.type == "img" ? null : (
        <p className="value" name={props.value ? props.value : "-"}>
          {props.value ? props.value : "-"}
        </p>
      )}
    </div>
  );
};

export default CustodianDetailCard;
